import { BaseComponentConfig, LinkObject } from '@interfaces/index';

import { ButtonTypeEnum, CmsComponentTypeEnum } from '@models/enums';

export namespace Cta {
  export const TypeEnum = CmsComponentTypeEnum.CTA;

  export enum Layout {
    STANDARD = 'STANDARD',
    SHORT = 'SHORT',
  }

  export interface ComponentConfig extends BaseComponentConfig {
    text: string;
    subText?: string;
    image?: { nodeId?: string; url?: string };
    link?: LinkObject;
    buttonType?: ButtonTypeEnum;
    layout: Layout;
    ctaBgColor?: string;
  }
}
